import * as React from 'react';
import { IControl, ControlHelper, PropertyHelper, IComponent } from '../../helpers';
import { Button, ButtonType } from 'office-ui-fabric-react';
import CascadeContainer from '../../containers/cascade';
import store from '../../store/store';

interface IProps {
    control: IControl;
    componentId: string;
    controlIndex: number;
    layoutPanelIndex?: number;
    toggleDialog: (componentId: string, controlIndex: number, previousOutputBlocks?: any, layoutPanelIndex?: number) => void;
    showBlockContent?: boolean;

    changeShowBlockContent?: (val: boolean) => void;
    component: IComponent;
    deleteControl?: (controlId: string) => void;

};

export class Control extends React.Component<IProps, any> {

    constructor(props: any) {
        super(props);

        this.changeShowBlockContent = this.changeShowBlockContent.bind(this)
    };

    changeShowBlockContent() {
        const newShowBlockContent = this.props.showBlockContent;
        this.props.changeShowBlockContent(newShowBlockContent);
    }

    public render() {

        let { control, controlIndex, layoutPanelIndex, componentId, toggleDialog, showBlockContent, changeShowBlockContent, component, deleteControl } = this.props;
        let label: string = PropertyHelper.getPropertyValue(control.Properties, 'Label');
        let isRequired: boolean = PropertyHelper.getPropertyValue(control.Properties, 'Required');
        let type: string = control.ControlType.NameType;
        let icon: string = getControlIcon(type);
        return <div className=" control ms-u-slideDownIn20 anim-1"
            draggable={true}
            onDragStart={(e) => ControlHelper.drag(e, componentId, controlIndex, layoutPanelIndex)}
            onDrop={(e) => ControlHelper.drop(e, controlIndex, layoutPanelIndex)}
            onDragOver={ControlHelper.allowDrop}>
            <div title={label}
                className='ms-Button ms-Button--command'
                //buttonType={ ButtonType.command }
                // onClick={() => {
                //     changeShowBlockContent(true);
                //     toggleDialog(componentId, controlIndex);
                // }}>
                onClick={() => {
                    changeShowBlockContent(true);
                    // toggleDialog(componentId, controlIndex);
                }}>
                <div className="config-head new-config-head">
                    <span className="component-name">

                        <i className={'ms-Icon ms-font-l ms-Icon--' + icon} aria-hidden="true"></i> {label}
                        {isRequired ? '*' : ''}
                    </span>


                    {this.props.deleteControl ?
                        <div className="actions control-child-header-icon">
                            <Button
                                buttonType={ButtonType.icon}
                                icon='Delete'
                                title='Delete this control'
                                className={'action '}
                                onClick={(event) => {
                                    toggleDialog(componentId, controlIndex, null, layoutPanelIndex);
                                    deleteControl(control.ControlId);
                                    event.stopPropagation();
                                }}
                            />
                        </div>
                        : null
                    }

                </div>

            </div>
            {/* {parseInt(store.getState().modalState.controlConfig.controlIndex) === controlIndex ?
                <CascadeContainer showBlockContent={showBlockContent} changeShowBlockContent={this.changeShowBlockContent} />
                : null} */}

        </div >;
    };

};

let getControlIcon = (type: string): string => {

    let icon: string;

    switch (type) {

        case 'Boolean':
            icon = 'CheckboxComposite';
            break;

        case 'Content Snippet':
            icon = 'PreviewLink';
            break;

        case 'Create Form':
            icon = 'Add';
            break;

        case 'Date Time':
            icon = 'DateTime';
            break;

        case 'Datatable':
        case 'Get View':
            icon = 'Table';
            break;

        case 'List Of Options':
            icon = 'Dropdown';
            break;

        case 'List Of Items':
            icon = 'BulletedList';
            break;

        case 'Numeric Value':
            icon = 'NumberField';
            break;

        case 'Multi Select Control':
            icon = 'MultiSelect';
            break;

        case 'Section':
            icon = 'Section';
            break;

        case 'LUIS Textbox':
        case 'Textbox':
            icon = 'TextField';
            break;

        case 'Google Map':
        case 'ESRI Map':
            icon = 'Globe';
            break;

        case 'File Upload':
            icon = 'OpenFile';
            break;

        case 'Address Search':
            icon = 'Search';
            break;

        case 'Booking':
            icon = 'Calendar';
            break;

    }

    return icon;

};


// WEBPACK FOOTER //
// ./source/ts/components/controls/control.tsx